import './documentation.scss';
import '../../shared/style/App.scss';
import '../../pages/lecture/style/lecture.scss';

export default () => {

    return (
        <>
            <section>
                <h1>Openlexia markup documentation</h1>

                <div className='doc__container'>
                    <div className='doc__container--title'>Headers</div>

                    <div className='doc__container-2col'>
                        <div className='doc__container--col1'>
                            # Header 1
                        </div>
                        <div className='doc__container--col2 lecture'>
                            <h1>Header 1</h1>
                        </div>
                    </div>
                    <div className='doc__container-2col'>
                        <div className='doc__container--col1'>
                            ## Header 2
                        </div>
                        <div className='doc__container--col2 lecture'>
                            <h2>Header 2</h2>
                        </div>
                    </div>
                    <div className='doc__container-2col'>
                        <div className='doc__container--col1'>
                            ### Header 3
                        </div>
                        <div className='doc__container--col2 lecture'>
                            <h3>Header 3</h3>
                        </div>
                    </div>


                </div>

                <div className="doc__container">
                    <div className="doc__container--title">Bold</div>

                    <div className="doc__container-2col">
                        <div className="doc__container--col1">
                            {`**bold**`}
                        </div>
                        <div className="doc__container--col2">
                            <strong>bold</strong>
                        </div>
                    </div>
                </div>

                <div className="doc__container">
                    <div className="doc__container--title">Italic</div>

                    <div className="doc__container-2col">
                        <div className="doc__container--col1">
                            {`*italic*`}
                        </div>
                        <div className="doc__container--col2">
                            <i>Italic</i>
                        </div>
                    </div>
                </div>

                <div className="doc__container">
                    <div className="doc__container--title">Insert audio</div>

                    <div className="doc__container-2col">
                        <div className="doc__container--col1">
                            inline audio: {`{ AUDIO | audioId}`}
                        </div>
                        <div className="doc__container--col2">
                            inline audio: <span className="clickable-icon">&#9205;</span>
                        </div>
                    </div>
                </div>

                <div className="doc__container">
                <div className="doc__container--title">Colors</div>

                    <div className="doc__container-2col">
                        <div className="doc__container--col1">
                            {`{ RED | color red}`}
                        </div>
                        <div className="doc__container--col2">
                            <span style={{ color: "red" }}>color red</span>
                        </div>
                    </div>
                    <div className="doc__container-2col">
                        <div className="doc__container--col1">
                            {`{ BLUE | color blue}`}
                        </div>
                        <div className="doc__container--col2">
                            <span style={{ color: "blue" }}>color blue</span>
                        </div>
                    </div>
                    <div className="doc__container-2col">
                        <div className="doc__container--col1">
                            {`{ GREEN | color green}`}
                        </div>
                        <div className="doc__container--col2">
                            <span style={{ color: "green" }}>color green</span>
                        </div>
                    </div>

                </div>

                <div className="doc__container">
                    <div className="doc__container--title">Table with header</div>

                    <div className="doc__container-2col">
                        <div className="doc__container--col1">
                            @table<br/>
                            | Header 1 | Header 2|<br/>
                            |--------------------|<br/>
                            | content  | content |<br/>
                            | content  | content |<br/>
                            | content  | content |<br/>
                        </div>
                        <div className="doc__container--col2">
                            <table className="lecture__table">
                                <thead>
                                    <tr><th>Header 1</th><th>Header 2</th></tr>
                                </thead>
                                <tbody>
                                    <tr><td>content</td><td>content</td></tr>
                                    <tr><td>content</td><td>content</td></tr>
                                    <tr><td>content</td><td>content</td></tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <div className="doc__container">
                    <div className="doc__container--title">Table without header</div>

                    <div className="doc__container-2col">
                        <div className="doc__container--col1">
                            @table<br/>
                            | content  | content |<br/>
                            | content  | content |<br/>
                        </div>
                        <div>
                            <table className="lecture__table">
                                <tbody>
                                    <tr><td>content</td><td>content</td></tr>
                                    <tr><td>content</td><td>content</td></tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <div className="doc__container">
                    <div className="doc__container--title">Writing exercise</div>

                    <div className="doc__container-2col">
                        <div className="doc__container--col1">
                            @write<br/>
                            Le chat ---se--- nettoie<br/>
                            ---Ce--- matin il faire chaud<br/>
                        </div>
                        <div className="doc__container--col2">
                            The form
                        </div>
                    </div>
                </div>


            </section>
        </>
    );

};
